import * as React from 'react'
import { ReactElement } from 'react'
import BaseCombobox from '../Combobox/BaseCombobox'
import useUnits from '../../hooks/useUnits'
import { UnitDto } from '../../context/GlobalContext'
import { BaseComboboxProps } from './BaseCombobox'

export type UnitComboboxProps = Omit<BaseComboboxProps<UnitDto>, 'entities' | 'getEntityLabel' | 'getEntityValue'>

export default function UnitCombobox(props: UnitComboboxProps): ReactElement {
    const { units } = useUnits()

    return (
        <BaseCombobox<UnitDto>
            entities={units}
            filter={unit => props.filter?.(unit) ?? (unit.enabled || props.selectedOptions?.includes(unit.key))}
            alphabetical
            getEntityLabel={unit => unit.name}
            getEntityValue={unit => unit.key}
            placeholderKey={'base.unitpicker.placeholder'}
            {...props}
        />
    )
}
